import React from 'react';
// import PropTypes from 'prop-types';

function Splash() {
  return (
    <div className="h-full w-full flex">
      <div className="text-center m-auto w-full max-w-sm loader-wrapper">
        <div className="text-gray-600">Loading...</div>
        <div className="loaderBar">
          <div className="loaderBarInner" />
        </div>
      </div>
    </div>
  );
}

Splash.propTypes = {};

export default Splash;
